import { Link } from 'react-router-dom';
import { PublicLayout } from '@/components/layout/PublicLayout';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';
import SEO from '@/components/SEO';

export default function CheckoutCancelPage() {
  return (
    <PublicLayout>
      <SEO
        title="Paiement Annulé"
        description="Votre paiement a été annulé. Votre panier est conservé, vous pouvez recommencer."
        canonical="/checkout/cancel"
        noindex={true}
      />
      <div className="py-20 px-6 lg:px-12">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-amber-600" />
          </div>
          <h1 className="font-heading text-3xl font-semibold mb-4" data-testid="cancel-title">
            Commande annulée
          </h1>
          <p className="text-muted-foreground mb-8">
            Votre commande a été annulée. Vos articles sont toujours dans votre panier 
            si vous souhaitez finaliser votre achat.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/panier" data-testid="back-to-cart-btn">
              <Button className="btn-primary w-full sm:w-auto">
                Retourner au panier
              </Button>
            </Link>
            <Link to="/commander-en-ligne" data-testid="continue-shopping-btn">
              <Button variant="outline" className="w-full sm:w-auto">
                Continuer mes achats
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
